import * as React from 'react';

export type LightboxUnsupportedTypeProps = {
    fileType: string;
    src?: React.ImgHTMLAttributes<HTMLImageElement>['src'];
};

export function LightboxUnsupportedType({ fileType, src }: LightboxUnsupportedTypeProps): JSX.Element {
    return (
        <div style={{ maxHeight: '80vh' }}>
            <img alt={fileType} data-testid="lightbox-unsupported-type-icon" src={src} />
        </div>
    );
}
LightboxUnsupportedType.displayName = 'LightboxUnsupportedType';
